import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import WhatsAppButton from '../common/WhatsAppButton/WhatsAppButton';
import './AppLayout.scss';

import { useCustomCursor } from '../../hooks/useCustomCursor';

const AppLayout = ({ children }) => {
  useCustomCursor();
  const location = useLocation();
  
  // Scroll to top on route change (except when navigating with state)
  useEffect(() => {
    if (!location.state?.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.state]);
  
  return (
    <div className="app-layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default AppLayout;
  